<template>

  <div>

      <banner> </banner>
      <div class="news_main">
          <!-- <div class="piace">
              <a href="/move">首页</a> &gt; 公司动态
          </div> -->

         <div  class="new_center">
              
               <h1 v-html="list.content.title"></h1>
               <div class="time">
                      <p v-html="list.content.create_time"></p>
               </div>

                <div class="word_main" v-html="list.content.content">
               </div>

        </div>

        <div class="news_bottom">
          <div class="fl" @click="newsup"  v-if="list.content.uptitle">上一篇</div>
          <div class="fr" @click="newsdown" v-if="list.content.downtitle">下一篇</div>
        </div>
      </div>
      
  </div>
</template>
      
<script>
      export default {
        data(){
            return({
             list:{
              isclass:true,
              msg:'123',
              news:'',
              content:[
                { 
                  id: '2',
                  title: "",
                  intro: "",
                  content: '',
                  create_time: '',
                  uptitle: '',
                  upId:'',
                  downtitle: '',
                  downId:''
                },
           
              ],
             }

            })
        },
        methods:{
          newsup (){
            this.getnews(this.list.content.upId)
          },
          newsdown() {
            this.getnews(this.list.content.downId)
          },
          async getnews(val){
            var dt = await this.$axios.post('/api/itemnewscut',{
              case:val,
              state:0
            })
            dt.data =  JSON.parse(dt.data)
            if (dt.status == 200) {
              if (dt.data.code !== 0) {
                this.$message({
                  type: 'info',
                  message: dt.data.msg
                });
                return;
              }
            } else {
              alert(dt.statusText)
              return;
            }
            // console.log(dt.data.data)
            this.list.content=dt.data.data
            this.$router.push({
              name: 'menews', params: {
                id: val + '.html',
              }
            })
          },

        },
        updated:function(){  
           window.scroll(0, 0);
          },
        created(){
          this.list.content.id = this.$route.params.id.split('.')[0]
          this.getnews(this.list.content.id);
          },
          watch: {
            $route(to, from) {
              this.getnews(this.$route.params.id.split('.')[0])
            }
          }

      }
      </script>
      
      <style lang=less scoped>
        .news_main{
            text-align: left;
            padding: 0  20px 0px;
            background: #fff;
            line-height: 25px;
            overflow: hidden;
          img{
            /* animation: go 2s ease 0s 2 ;   声明动画 */
            width: 100%;
          }

          .piace{
           
            text-align: left;
            color: #666;
            margin-top: 30px;
            a{
              color: #666;
            }
          }

          .new_center{
            padding: 25px 0 ;

            h1{
              font-size: 24px;
              color: #333;
              text-align: center;
              font-weight: 300;
            }

            .time{
              overflow: hidden;
              position: relative;
              p{
                font-size: 12px;
                color: #777777;
                line-height: 34px;
                width: 50%;
                margin: 0  auto;
                background: #fff;
                padding: 10px 3px;
                text-align:center
              }
            }

            .time::after{
               content: "";
               position: absolute;
               width: 25%;
               height: 1px;
               background: #d7d8d8;
               top: 50%;
               left: 0;
               display: inline-block;
            }


            .time::before{
               content: "";
               position: absolute;
               width: 25%;
               height: 1px;
               background: #d7d8d8;
               top: 50%;
               right: 0;
               display: inline-block;
            }

            .word_main{
              font-size: 16px;
              line-height: 26px;
              min-height: 150px;
              color: #333333;

              img{
                margin: 10px 0;
                max-width: 100%;
              }
            }
          }


          .news_bottom{
            border-top: 1px dotted #999 ;
            font-size: 14px;
            color: #959595;
            padding: 15px 0 15px;
            text-align: center;
            overflow: hidden;
          }
          
        }
      

    
      </style>


// WEBPACK FOOTER //
// src/components/move/news.vue